import { useMutation, useQuery } from '@tanstack/react-query';
import { store } from '../..';
import { queryClient } from '../../..';
import { setAlert, setIsLoading } from '../../components/components-slice';
import { itfApis } from './../../../api/payroll/statutory-compliance/itf';
import moment from 'moment';
import { formatNumber } from '../../../utils/functions';

export function useGetItfHistory(limit, page, statusFilter, search) {
  return useQuery(
    ['itf', { limit, page, statusFilter, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return itfApis.getITF({
        limit,
        page,
        statusFilter,
        search,
      });
    },
    {
      select(data) {
        data?.data?.forEach((itf) => {
          itf.created = moment(itf.created).format('MMMM DD, YYYY');
          itf.month = moment(itf.month).format('MMMM, YYYY');
          itf.status = parseFloat(itf.itf_status)
          if (itf.status === 2) {
            itf.status = 0
          }
          switch (itf.status) {
            case 0:
              itf.computedActions = [0];
              break;
            case 1:
              itf.computedActions = [1];
              break;
            default:
              break;
          }
        });

        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}

export function useUploadItf() {
  return useMutation(
    (payload) => {
      return itfApis.bulkITF(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('itf');
        store.dispatch(setAlert(true, 'success', 'Upload Successful'));
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
    },
  );
}

export function useRefITF(refId, limit, page, search) {
  return useQuery(
    ['itf-by-ref', { refId, limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return itfApis.fetchITFByRef({ refId, limit, page, search });
    },
    {
      select: (data) => {
        data?.data?.forEach((item) => {
          item.employeeName = `${item.first_name} ${item.last_name}`;
          if (!item.status) {
            item.status = 0
          }
          item.formatted_amount = formatNumber(parseFloat(item.amount.toFixed(2)), 2);
        });
        if (data) {
          data.formatted_total_amount = formatNumber(parseFloat(data?.total_amount.toFixed(2)), 2);
          data.formatted_total_trans_cost = formatNumber(parseFloat(data?.total_trans_cost.toFixed(2)), 2);
          data.formatted_total_payable = formatNumber(parseFloat(data?.total_payable.toFixed(2)), 2);
        }
        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
    },
  );
}